import React from "react";

function Navbar() {
  return (
    <nav className="navbar">
      <h2>Vidhya Boutique</h2>
      <ul>
        <li>Home</li>
        <li>Collections</li>
        <li>Contact</li>
      </ul>
    </nav>
  );
}

export default Navbar;
